import {ProductItem, GiftCertificateItem} from 'coreStore/data/basket/types';

/**
 * Represents an order line item
 */
abstract class LineItemModel {
	protected item: ProductItem | GiftCertificateItem

	/**
	 * @constructor
	 * @param {ProductItem | GiftCertificateItem} item - The gift certificate item
	 */
	constructor(item) {
		this.item = item;
	}
}

export default LineItemModel;
